export default __webpack_public_path__ + "static/media/category_18.6bee9a2b.png";